<div id="content" class="allcp-form" ng-controller="AccountController" ng-init="init()">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    <div class="row">
        <div class="panel">

            <div class="panel-heading">
                <span class="panel-title"> Ayarlar</span>
                <hr>
            </div>
            
            <div class="panel-body allcp-form theme-primary">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <form class="form-horizontal" ng-submit="updateCompanyInfo()">

                            <div class="row">
                                <div class="col-md-12">
                                    <h5>Anasayfa</h5>
                                    
                                    <div class="checkbox-custom checkbox-success mb5">
                                        <input type="checkbox" ng-checked="setting.dashboard_map == 1" ng-model="setting.dashboard_map" id="dashboard_map">
                                        <label for="dashboard_map">
                                            Anasayfada ki mapyı şirket konumum olarak sabitle.

                                            <p class="text-muted">
                                                 
                                                Eğer bu seçimi yaparsanız takip sayfasında bulunan map otomatik olarak, Şirket Bilgileri içerisinde seçmiş olduğunu konuma odaklanacaktır. Eğer seçimi yapmazsanız; map üzerinde bulunan pinlere göre otomatik olarak şekillenecektir.
                                            </p>
                                        </label>
                                    </div>

                                </div>
                                <div class="col-md-12">
                                    <h5>Canlı Takip</h5>
                                    
                                    <div class="checkbox-custom checkbox-success mb5">
                                        <input type="checkbox" ng-checked="setting.tracking == 1" ng-model="setting.tracking" id="tracking">
                                        <label for="dashboard_map">
                                            Canlı takibi kullan.

                                            <p class="text-muted">
                                                 
                                                Eğer bu seçimi yaparsanız Teleskop uygulaması kullanan personellerinizi canlı olarak map üzerinden takip edebileceksiniz. Eğer iş süreciniz canlı takibi gerektirmiyorsa bu seçeneği pasif hale getirerek Teleskop uygulaması kullanan personellerinizin şarj kullanımını artırabilirsiniz.
                                            </p>
                                        </label>
                                    </div>

                                </div>

                                <div class="col-md-12 mt30">
                                    <button type="submit" class="btn btn-primary">Güncelle</button>
                                </div>
                            </div>
                            
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>